import { render, staticRenderFns } from "./Bundle.vue?vue&type=template&id=54de7bc6&scoped=true"
import script from "./Bundle.vue?vue&type=script&lang=js"
export * from "./Bundle.vue?vue&type=script&lang=js"
import style0 from "./Bundle.vue?vue&type=style&index=0&id=54de7bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54de7bc6",
  null
  
)

export default component.exports